import { render, staticRenderFns } from "./DoKoDialogWaitingForFriends.vue?vue&type=template&id=40a11c4c&scoped=true&"
import script from "./DoKoDialogWaitingForFriends.vue?vue&type=script&lang=ts&"
export * from "./DoKoDialogWaitingForFriends.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoDialogWaitingForFriends.vue?vue&type=style&index=0&id=40a11c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a11c4c",
  null
  
)

export default component.exports